export default {"src":"/_next/static/media/transactionDrawer.df547f64.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};